interface PageIndicatorProps {
  currentPage: number;
  totalPages: number;
}

export function PageIndicator({ currentPage, totalPages }: PageIndicatorProps) {
  return (
    <div className="fixed right-6 top-1/2 -translate-y-1/2 z-50 flex flex-col gap-3">
      {Array.from({ length: totalPages }).map((_, index) => (
        <div
          key={index}
          className={`rounded-full transition-all duration-300 ${
            currentPage === index
              ? 'bg-blue-600 w-3 h-8'
              : 'bg-gray-300 w-3 h-3'
          }`}
        />
      ))}
    </div>
  );
}

